import { gql } from '@apollo/client';
import KEYBOARDING_STUDENT_SETTINGS_FRAGMENT from '../../fragments/keyboarding-student-settings';

const GET_KEYBOARDING_STUDENT_SETTINGS = gql`
  query keyStudentSettings($where: PliStudentSettingsWhereInput!) {
    keyStudentSettings(where: $where) {
      ...BaseKeyboardingStudentSettings
    }
  }
  ${KEYBOARDING_STUDENT_SETTINGS_FRAGMENT}
`;

export default GET_KEYBOARDING_STUDENT_SETTINGS;
